import { useEffect, useRef, useState } from "react";
import { openModal } from "risa-oasis-ui_v2";
import EmbedPDFModal from "../../../components/modals/embedPDFmodal/embedPDFmodal";
import { FinalWorklistDataResponse } from "../../../data-model/finalWorklistModel";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../../store/UserGeneralInfoStore";
import FinalWorklistOrdersTable from "./components/finalWorklistOrdersTable";

interface MedicalPaOrdersProps {
  onComplete?: boolean;
}

const FinalWorklist = (props: MedicalPaOrdersProps) => {
  const medicalPaOrdersTableRef = useRef<HTMLDivElement>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<string>("");
  const [selectedRowData, setSelectedRowData] = useState<
    FinalWorklistDataResponse | undefined
  >(undefined);

  // Use viewLegacy from singleton store
  const isViewLegacy = UserStore.getItem(
    UserGeneralInfoContextKeys.VIEW_LEGACY,
  );

  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  useEffect(() => {
    if (isPDFModalOpen) {
      openModal("embed-pdf-modal");
    }
  }, [isPDFModalOpen]);

  useEffect(() => {
    // Store parent table in singleton store
    UserStore.setItem(
      UserGeneralInfoContextKeys.PARENT_TABLE,
      window.location.pathname.split("/").slice(-1)[0],
    );
  }, []);

  return (
    <div
      className={`medical-pa-orders--main-container flex h-full flex-col overflow-hidden ${
        isViewLegacy ? "p-3" : ""
      }`}
    >
      <div className="medical-pa-orders__header mb-4 flex items-center justify-between text-h11 font-bold text-primaryGray-1">
        All PA Orders
      </div>

      <div className="medical-pa-orders__table-container flex-1 overflow-auto">
        <FinalWorklistOrdersTable
          medicalPaOrdersTableRef={medicalPaOrdersTableRef}
          onDataChange={() => {}}
          onComplete={false}
          onBulkAssignButtonClick={() => {}}
          onDownloadButtonClick={(
            id: string,
            rowData?: FinalWorklistDataResponse,
          ) => {
            setSelectedOrderId(rowData?.upload_id ?? "");
            setSelectedRowData(rowData);
            setIsPDFModalOpen(true);
          }}
        />
      </div>
      {isPDFModalOpen && (
        <EmbedPDFModal
          id={selectedOrderId}
          isModalOpen={isPDFModalOpen}
          onClose={() => setIsPDFModalOpen(false)}
          rowData={selectedRowData}
          uploadId={selectedOrderId}
        />
      )}
    </div>
  );
};

export default FinalWorklist;
